<template>
    <div id="app">
        <div class="header-fixed">
            <transition name="transitionFade">
                <cookie-banner v-if="!hasAcceptedCookies" />
            </transition>

            <transition name="transitionFade">
                <router-view name="topNavigation"></router-view>
            </transition>
        </div>

        <div class="router__container" :key="$route.fullPath">
            <transition :name="transitionName">
                <router-view :key="$route.fullPath"></router-view>
            </transition>
        </div>

        <router-view name="orderSummaryModal"></router-view>

        <transition name="transitionFade">
            <tool-tip-modal :showToolTipModal="showToolTipMdal" :fields="toolTipData"></tool-tip-modal>
        </transition>

        <transition name="transitionFade">
                <router-view :name="footer" :pageName="$route.name"></router-view>
        </transition>

        <country-switch-modal v-show="showCountryModal" :appLocation="appLocation" :userLocation="userLocation"/>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { turnScrollOff, turnScrollOn } from '@/helpers/ScrollHelpers.js';
import CountrySwitchModal from '@/components/modals/CountrySwitchModal';
import Countries from '@/resources/countrySwitcher.json';
import CookieBanner from '@/components/structure/CookieBanner.vue';
import ToolTipModal from '@/components/modals/ToolTipModal.vue';
import { prefillZDForm } from '@/helpers/ZendeskHelpers.js';

export default {
    name: 'FrontEndWebsite',
    data() {
        return {
            transitionName: '',
            userInDifferentLocation: false,
            appLocation: null,
            userLocation: null,
            showToolTipMdal: false,
            toolTipData: null,
        };
    },
    components: {
        CountrySwitchModal,
        CookieBanner,
        ToolTipModal,
    },
    computed: {
        ...mapGetters({
            hasAnsweredCountrySwitch: 'account/getHasAnsweredCountrySwitch',
            hasAcceptedCookies: 'cookies/getHasAnsweredCookieForm',
            scrollbarEnabled: 'account/getScrollbarEnabled',
            isUserLoggedIn: 'auth/isUserLoggedIn',
            butterCMSDataAvailable: 'cms/getButterCMSDataAvailable',
            customerFullName: 'account/getFullName',
            customerEmail: 'account/getEmail',
            couponCode: 'register/getCouponCode',
        }),
        showCountryModal() {
            return this.userInDifferentLocation && !this.hasAnsweredCountrySwitch;
        },
        footer() {
            if (this.$route.name === 'home') return this.butterCMSDataAvailable ? 'footer' : null;
            return !this.isUserLoggedIn ? null : 'footer';
        },
        couponCookie() {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; couponCode=`);

            return parts.length === 2 ? parts.pop().split(';').shift() : null;
        },
    },
    mounted() {
        this.$root.$on('show-tool-tip-modal', this.showToolTip);
        this.$root.$on('hide-tool-tip-modal', this.hideToolTip);
        if (this.$globalQueryParams?.accessibility) {
            this.$store.commit('account/setScrollbarEnabled', true);
        }
        if (!this.scrollbarEnabled) {
            this.$store.commit('account/setScrollbarEnabled', false);
        }

        this.$store.commit('cookies/setAwcValue', this.$route.query.awc);
        this.$store.dispatch('cookies/mountScripts');
        setTimeout(() => {
            const location = JSON.parse(sessionStorage.getItem('ABTastyGeoloc'));
            const appIso = process.env.VUE_APP_COUNTRY_ISO;
            this.appLocation = Countries.find(country => country.geocode === appIso || country.iso === appIso);
            this.userLocation = Countries.find(country => (location && location.country_iso_code === country.geocode) || (location && location.country_iso_code === country.iso));

            // if the users location is available in the country list, then we can show the modal if its a different location from the app location
            this.userInDifferentLocation = this.appLocation && this.userLocation && this.userLocation.iso !== this.appLocation.iso;
            prefillZDForm(this.customerFullName, this.customerEmail, this.isUserLoggedIn);
        }, 2000);

        const params = new URLSearchParams(location.search);
        if (!this.couponCookie && params.get('c') && params.get('c')?.toLowerCase() !== this.couponCode?.toLowerCase()) document.cookie = `couponCode=${params?.get('c')}; expires=${new Date((new Date()).setMonth((new Date()).getMonth() + 1))}; path=/`;

        this.couponCookie && this.$store.commit('register/setCouponCode', this.couponCookie);
    },
    methods: {
        showToolTip(payload) {
            turnScrollOff(document);
            this.toolTipData = payload;
            this.showToolTipMdal = true;
        },
        hideToolTip() {
            turnScrollOn(document);
            this.showToolTipMdal = false;
        },
    },
    watch: {
        '$route'(to, from) {
            if (to.meta?.order && from.meta?.order) {
                this.transitionName = to.meta.order > from.meta.order ? 'transitionSlideNext' : 'transitionSlidePrevious';
            } else {
                this.transitionName = 'transitionFade';
            }
        },
    },
};
</script>

<style lang="scss">
    @import "@/assets/sass/app.scss";

    .header-fixed {
        position: fixed;
        z-index: 1000;
        width: 100%;
    }
</style>
